import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../context/DarkModeContext';
import { CheckCircleIcon, CreditCardIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
import { useDarkClasses } from '../hooks/useDarkClasses';
import { useRoleTheme } from '../hooks/useRoleTheme';
const Checkout = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    cardName: '',
    cardNumber: '',
    expDate: '',
    cvc: ''
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      // Process payment logic here
      alert('Order placed successfully!');
    }
  };
  return <div className={`min-h-screen py-12 px-4 sm:px-6 lg:px-8 ${dk.page}`} data-id="element-8224" data-mp="85eyx1zdg9zy">
      <div className="max-w-3xl mx-auto" data-id="element-8225" data-mp="cx6gin0jv5dy">
        {/* Progress Steps */}
        <nav aria-label="Progress" className="mb-12" data-id="element-8226" data-mp="hwjcpydb9ot7">
          <ol role="list" className="flex items-center" data-id="element-8227" data-mp="hvzwqn781aht">
            <li className={`relative pr-8 sm:pr-20 ${step > 1 ? rt.textPrimary : dk.textMuted}`} data-id="element-8228" data-mp="3geoocugboced">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8229" data-mp="3leb4bbnjc6qv">
                <div className={`h-0.5 w-full ${step > 1 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8230" data-mp="3qefj8x8sotez"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 1 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8231" data-mp="15lkg377ae9rm">
                <CheckCircleIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-8232" data-mp="36mibrac539za" />
                <span className="sr-only" data-id="element-8233" data-mp="3forkpvrrevak">Step 1</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 1 ? rt.textPrimary : dk.textMuted}`} data-id="element-8234" data-mp="3fmx9j96aihjo">
                Shipping
              </span>
            </li>
            <li className={`relative px-8 sm:px-20 ${step > 2 ? rt.textPrimary : dk.textMuted}`} data-id="element-8235" data-mp="2iz0nhos32u12">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8236" data-mp="2wr74te6z3723">
                <div className={`h-0.5 w-full ${step > 2 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8237" data-mp="2rxcehrwv3tu1"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 2 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8238" data-mp="1za00450uusbt">
                <CreditCardIcon className={`h-5 w-5 ${step >= 2 ? 'text-white' : dk.textMuted}`} aria-hidden="true" data-id="element-8239" data-mp="jkqqs60pmbmu" />
                <span className="sr-only" data-id="element-8240" data-mp="as6zxrqntbck">Step 2</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 2 ? rt.textPrimary : dk.textMuted}`} data-id="element-8241" data-mp="ygzp95cs0ky7">
                Payment
              </span>
            </li>
            <li className={`relative pl-8 sm:pl-20 ${step > 3 ? rt.textPrimary : dk.textMuted}`} data-id="element-8242" data-mp="ohh96zzzljbf">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8243" data-mp="tfshv7ejpns2">
                <div className={`h-0.5 w-full ${step > 3 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8244" data-mp="3e7ktqoetk2yz"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 3 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8245" data-mp="3tjls33xy2y21">
                <ShieldCheckIcon className={`h-5 w-5 ${step >= 3 ? 'text-white' : dk.textMuted}`} aria-hidden="true" data-id="element-8246" data-mp="3fq2xru3t6vko" />
                <span className="sr-only" data-id="element-8247" data-mp="ga6alu6tb750">Step 3</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 3 ? rt.textPrimary : dk.textMuted}`} data-id="element-8248" data-mp="caff5d6cc2u5">
                Review
              </span>
            </li>
          </ol>
        </nav>

        <div className={`shadow overflow-hidden sm:rounded-lg ${dk.card}`} data-id="element-8249" data-mp="2s0ie18ztzuac">
          <div className="px-4 py-5 sm:px-6" data-id="element-8250" data-mp="2ryfenycsgosy">
            <h3 className={`text-lg leading-6 font-medium ${dk.textHeading}`} data-id="element-8251" data-mp="2n15qsn51sl78">
              {step === 1 ? 'Shipping Information' : step === 2 ? 'Payment Details' : 'Review Order'}
            </h3>
            <p className={`mt-1 max-w-2xl text-sm ${dk.textMuted}`} data-id="element-8252" data-mp="2mvoc6ra07xge">
              {step === 1 ? 'Please enter your shipping details.' : step === 2 ? 'Enter your payment information securely.' : 'Review your order before placing it.'}
            </p>
          </div>
          <div className={`border-t ${dk.border}`} data-id="element-8253" data-mp="30m9w8jb72dfv">
            <form onSubmit={handleSubmit} className="px-4 py-5 sm:p-6" data-id="element-8254" data-mp="30p5s823hes1o">
              {step === 1 && <div className="grid grid-cols-6 gap-6" data-id="element-8255" data-mp="35kbi1c008qv1">
                  <div className="col-span-6 sm:col-span-3" data-id="element-8256" data-mp="3ajxuvkbx853b">
                    <label htmlFor="first-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8257" data-mp="1b8emp7yfz0up">
                      First name
                    </label>
                    <input type="text" name="firstName" id="first-name" autoComplete="given-name" value={formData.firstName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8258" data-mp="187bfr7tybp7m" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8259" data-mp="1m59o9wllcrf7">
                    <label htmlFor="last-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8260" data-mp="20uxtva0t2c8q">
                      Last name
                    </label>
                    <input type="text" name="lastName" id="last-name" autoComplete="family-name" value={formData.lastName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8261" data-mp="29wxai17wreb5" />
                  </div>

                  <div className="col-span-6 sm:col-span-4" data-id="element-8262" data-mp="2kg7paz3a0mxr">
                    <label htmlFor="email-address" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8263" data-mp="25s367u0ba9eg">
                      Email address
                    </label>
                    <input type="text" name="email" id="email-address" autoComplete="email" value={formData.email} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8264" data-mp="1wsg2h1k40ri8" />
                  </div>

                  <div className="col-span-6" data-id="element-8265" data-mp="22aqhsrpvo4cz">
                    <label htmlFor="street-address" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8266" data-mp="22c1r1723e4bh">
                      Street address
                    </label>
                    <input type="text" name="address" id="street-address" autoComplete="street-address" value={formData.address} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8267" data-mp="1oc0o7m29omtd" />
                  </div>

                  <div className="col-span-6 sm:col-span-6 lg:col-span-2" data-id="element-8268" data-mp="10ld1hunozsmr">
                    <label htmlFor="city" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8269" data-mp="10o92jruu6xff">
                      City
                    </label>
                    <input type="text" name="city" id="city" autoComplete="address-level2" value={formData.city} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8270" data-mp="3m6wctduty4q6" />
                  </div>

                  <div className="col-span-6 sm:col-span-3 lg:col-span-2" data-id="element-8271" data-mp="37a5b2xxoogxe">
                    <label htmlFor="region" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8272" data-mp="37c9n635qkm8r">
                      State / Province
                    </label>
                    <input type="text" name="state" id="region" autoComplete="address-level1" value={formData.state} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8273" data-mp="2686n9n2a203q" />
                  </div>

                  <div className="col-span-6 sm:col-span-3 lg:col-span-2" data-id="element-8274" data-mp="1rir0sj9s4gtu">
                    <label htmlFor="postal-code" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8275" data-mp="1rgocq4s6sxrr">
                      ZIP / Postal code
                    </label>
                    <input type="text" name="zip" id="postal-code" autoComplete="postal-code" value={formData.zip} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8276" data-mp="13tpup2of5hrq" />
                  </div>
                </div>}

              {step === 2 && <div className="grid grid-cols-6 gap-6" data-id="element-8277" data-mp="nb1zinaoxwoi">
                  <div className="col-span-6 sm:col-span-3" data-id="element-8278" data-mp="iaxsdnvoaeay">
                    <label htmlFor="card-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8279" data-mp="dj61fc8lu6ka">
                      Name on card
                    </label>
                    <input type="text" name="cardName" id="card-name" autoComplete="cc-name" value={formData.cardName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8280" data-mp="3m1bd1bn1qy7" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8281" data-mp="374pdyrqtex7f">
                    <label htmlFor="card-number" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8282" data-mp="3768tuh8k768o">
                      Card number
                    </label>
                    <input type="text" name="cardNumber" id="card-number" autoComplete="cc-number" value={formData.cardNumber} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8283" data-mp="8mjsz51wyx9l" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8284" data-mp="2c2nhs7pf3bcd">
                    <label htmlFor="expiration-date" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8285" data-mp="2c0u6gf3v02y1">
                      Expiration date (MM/YY)
                    </label>
                    <input type="text" name="expDate" id="expiration-date" autoComplete="cc-exp" value={formData.expDate} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8286" data-mp="2guyg564iep2t" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8287" data-mp="3djd2pzcevcz5">
                    <label htmlFor="cvc" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8288" data-mp="38l375nmryad0">
                      CVC
                    </label>
                    <input type="text" name="cvc" id="cvc" autoComplete="cc-csc" value={formData.cvc} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8289" data-mp="cof181ez7r37" />
                  </div>
                </div>}

              {step === 3 && <div className="space-y-6" data-id="element-8290" data-mp="10f1blzcgdngd">
                  <div className={`p-4 rounded-md ${dk.surfaceMuted}`} data-id="element-8291" data-mp="15dm8boshxp02">
                    <h4 className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-8292" data-mp="15foyc8tnfi4s">
                      Shipping Address
                    </h4>
                    <p className={`mt-2 text-sm ${dk.textSecondary}`} data-id="element-8293" data-mp="1edsmlcw0qt0a">
                      {formData.firstName} {formData.lastName}
                      <br data-id="element-8294" data-mp="2yxwc0jo7t19g" />
                      {formData.address}
                      <br data-id="element-8295" data-mp="2uuhv7qsgcguy" />
                      {formData.city}, {formData.state} {formData.zip}
                    </p>
                  </div>
                  <div className={`p-4 rounded-md ${dk.surfaceMuted}`} data-id="element-8296" data-mp="2pvwtto1grr4x">
                    <h4 className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-8297" data-mp="2kxvbj5bv3vui">
                      Payment Method
                    </h4>
                    <p className={`mt-2 text-sm ${dk.textSecondary}`} data-id="element-8298" data-mp="3im53ssluj58f">
                      Card ending in {formData.cardNumber.slice(-4)}
                    </p>
                  </div>
                  {/* Order summary would go here */}
                </div>}

              <div className="mt-6 flex justify-end" data-id="element-8299" data-mp="33v5xxpceausj">
                {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className={`mr-3 px-4 py-2 rounded-md text-sm font-medium ${rt.outlineButton}`} data-id="element-8300" data-mp="567dt7p0xzan">
                    Back
                  </button>}
                <button type="submit" className={`px-4 py-2 rounded-md text-sm font-medium ${rt.primaryButton}`} data-id="element-8301" data-mp="1ynmx2b1qbqqm">
                  {step === 3 ? 'Place Order' : 'Next'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default Checkout;